module.exports = __webpack_public_path__ + "img/im_scrollfeature_16.0272f3c1.jpg";